export const employerPOCMappingTo9035SectionD = {
    name: "Employer POC Form Mapping",
    machine_name: "employer_9035_profile_mapping",
    targetFormDetailName: "LCA-9035",
    targetSectionName: "Requestor Point-of-Contact</br> Information",
    targetSectionLabel: "D",
    fields: [
      {
        profileFieldName: "poc_emp_last_name",
        formTargetField: "d1_poc_last"
      },
      {
        profileFieldName: "poc_emp_first_name",
        formTargetField: "d2_poc_first"
      },
      {
        profileFieldName: "poc_emp_middle_name",
        formTargetField: "d3_poc_middle"
      },
      {
        profileFieldName: "poc_emp_job_title",
        formTargetField: "d4_poc_title"
      },
      {
        profileFieldName: "poc_emp_address1",
        formTargetField: "d5_poc_address_1"
      },
      {
        profileFieldName: "poc_emp_address2",
        formTargetField: "d6_poc_address_2"
      },
      {
        profileFieldName: "poc_emp_city", 
        formTargetField: "d7_poc_city"
      },
      {
        profileFieldName: "poc_emp_country_id", 
        formTargetField: "d10_poc_country_id"
      },
      {
        profileFieldName: "poc_emp_state_id",
        formTargetField: "d8_poc_state_id"
      },
      {
        profileFieldName: "poc_emp_zip",
        formTargetField: "d9_poc_zip"
      },
      {
        profileFieldName: "poc_emp_province", 
        formTargetField: "d11_poc_province"
      },
      {
        profileFieldName: "poc_emp_phone",
        formTargetField: "d12_poc_phone"
      },
      {
        profileFieldName: "poc_emp_phone_ext",
        formTargetField: "d13_poc_phone_ext"
      },
      {
        profileFieldName: "poc_emp_email",
        formTargetField: "d14_poc_email"
      }
    ]
  };
  
  export const employerMappingTo9035SectionC = {
    name: "Employer Profile Form Mapping",
    machine_name: "employer_9035_profile_mapping",
    targetFormDetailName: "LCA-9035",
    targetSectionName: "Employer Information",
    targetSectionLabel: "C",
    fields: [
      {
        profileFieldName: "new_profile_emp_legal_name",
        formTargetField: "c1_emp_name"
      },
      {
        profileFieldName: "new_profile_emp_dba",
        formTargetField: "c2_emp_dba"
      },
      {
        profileFieldName: "new_profile_emp_address1",
        formTargetField: "c3_emp_address_1"
      },
      {
        profileFieldName: "new_profile_emp_address2",
        formTargetField: "c4_emp_address_2"
      },
      {
        profileFieldName: "new_profile_emp_city",
        formTargetField: "c5_emp_city"
      },
      {
        profileFieldName: "new_profile_emp_state_id",
        formTargetField: "c6_emp_state_id"
      },
      {
        profileFieldName: "new_profile_emp_zip",
        formTargetField: "c7_emp_zip"
      },
      {
        profileFieldName: "new_profile_emp_country_id",
        formTargetField: "c8_emp_country_id"
      },
      {
        profileFieldName: "new_profile_emp_province",
        formTargetField: "c9_emp_province"
      },
      {
        profileFieldName: "new_profile_emp_phone",
        formTargetField: "c10_emp_phone"
      },
      {
        profileFieldName: "new_profile_emp_phone_ext",
        formTargetField: "c11_emp_phone_ext"
      },
      {
        profileFieldName: "new_profile_emp_fein",
        formTargetField: "c12_emp_fein"
      },
      {
        profileFieldName: "new_profile_emp_naics_description",
        formTargetField: "c13_emp_naics_description"
      },
      {
        profileFieldName: "new_profile_emp_naics",
        formTargetField: "c13_emp_naics"
      },
    ]
  };
  